import { matchEquiment } from "../assets/js/matchEquiment";

export default {
  trackEventLabel: "",
  hasToken: false,
  currentLang: "en",
  currentSymbol: "",
  dialCode: 0,
  phoneHeaderLogoFlag: false,
  currentPackage: "",
  currentPaymentMethod: "",
  needAuthorization: true,
  flagList: [],
  defaultActiveLink: {
    home: false,
    download: false,
  },
  isOpenLeftSidebar: null,
  mediaType: matchEquiment(),
  redirectUrl: "/dashboard",
  pauseServeInfo: "",
  isHeader: false,
  stripe: null,
  card: null,
  cardError: "",
  cardNumberEmpty: true,
  nameError1: false,
  clickIndexPagePackageData: null,
};



// WEBPACK FOOTER //
// ./src/store/state.js